import { render, staticRenderFns } from "./NewCharity.vue?vue&type=template&id=4d4d19fe&scoped=true&"
import script from "./NewCharity.vue?vue&type=script&lang=js&"
export * from "./NewCharity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d19fe",
  null
  
)

export default component.exports